
import React from 'react';

const Modal = ({ show, handleClose }) => {
  return (
    <div className={`fixed inset-0 flex items-center justify-center ${show ? 'block' : 'hidden'} bg-black bg-opacity-50 p-4`} onClick={handleClose}>
      <div className="bg-white p-6 rounded shadow-md" onClick={e => e.stopPropagation()}>
        <h2 className="text-xl mb-4">Are you sure?</h2>
        <div className="flex justify-around">
          <button className="bg-darkteal text-white px-4 py-2 rounded" onClick={handleClose}>No</button>
          <button className="bg-darkteal text-white px-4 py-2 rounded" onClick={() => alert('Yes clicked')}>Yes</button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
